import React, { useState } from 'react';
import Row from "react-bootstrap/Row";

const Late = ({ setShowTemp, setShowLate }) => {
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState("");

    const handleChange = (e) => {
        const value = e.target.value;
        setPassword(value);
    };
    const handleClick = (e) => {
        if (password === 'sslatereg2026') {
            setShowTemp(0);
            setShowLate(0);
        } else {
            setMessage("Invalid Password");
        }
    };

    return (
        <>


            <div className="text-center mb-4">
                <h1>  Sara Schenirer 2026-27 LATE Dual Credit Course Registration  </h1>

                <div className="text-center mb-4">
                    <p>We are no longer accepting registrations this year. </p>
                </div>
                {/*<p className="alert alert-info">Prior authorization from Mrs. Lieba Berger is required to register for courses at this time.*/}
                {/*    </p><p>If you have any questions, reach out to Mrs. Berger at <a href="mailto:lberger@sarasch.com">lberger@sarasch.com</a>.</p>*/}
            </div>
                 {/*<Row className="mb-3 text-start">
                <h4 className="text-center">Enter password </h4>
            </Row>
            <Row className="mb-3 text-center">
                <input
                    type="text"
                    value={password}
                    onChange={handleChange}
                    placeholder="Enter password"
                />
            </Row>
            <Row>
                <button onClick={handleClick} className="btn btn-primary">SUBMIT</button>
                {message && (
                    <div className="mt-4 alert alert-danger">{message}</div>
                )}
            </Row>*/}
        </>
    );
};

export default Late;